// Passes the currently-selected component ID to TargetVersionSuggester so the
// autocomplete returns only target-version labels in use for that component subtree.
window.versionSuggesterParams = function() {
	let comp = $('#component').val();
	if (comp == null || comp.length === 0) return "component=0";
	return "component="+comp;
}
